var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewsListPage',{attrs:{"title":"其他新闻","category-name":"其它新闻","category-path":"other","root-class":"other-news","page-size":6}})
}
var staticRenderFns = []

export { render, staticRenderFns }